<template>
    <div class="solution_container">
        <img class="solution_title_img" :src="mediaPath" alt="before you enter" />
        <img v-if="isMatching" class="solution_img" src="@/assets/img/ppe/right-answer-icon.png" alt="Right answer" />
        <img v-else class="solution_img" src="@/assets/img/ppe/wrong-answer-icon.png" alt="wrong answer" />
        <p class="solution_info" v-html="isMatching ? properties.right : properties.wrong"></p>
        <!-- <p class="solution_description">Here is the PPE you should wear:</p> -->
        <section v-if="properties.scene == 'Warehouse'" class="warehouse_container">
            <p class="warehouse_bump"><span>Bump cap</span><br/>
                Bump caps protect from minor impacts and are ideal for areas with risk of accidental contact and moving or low-hanging objects.</p>
                <p class="warehouse_gloves"><span>Safety gloves</span><br/>
                    Safety gloves protect hands from hazards and may ensure hygiene. Choose the right type for your workplace’s specific risks.</p>
                    <p class="warehouse_glasses"><span>Safety glasses</span><br/>
                        Safety glasses protect against hazards like flying debris, dust, chemical splashes, and UV radiation, essential for workplace safety.</p>
                    <p class="warehouse_vest"><span>High visibility vest</span><br/>
                        Hi-vis clothing ensures safety by enhancing visibility, thereby offering protection and preventing accidents.</p>
                    <p class="warehouse_shoes"><span>Safety shoes</span><br/>
                        Safety shoes protect against workplace hazards, offer slip resistance, stability, and meet regulatory standards. Furthermore the right shoes in the right area ensures the hygiene and food safety.</p>
            <img class="warehouse_doll" src="@/assets/img/ppe/result_warehouse.png" alt="warehouse doll"/>
            <div class="btn_enter" @click="closeComponent">ENTER ROOM</div>
        </section>
        <section v-if="properties.scene == 'Production'" class="production_container">
            <p class="production_hair"><span>Hair net</span><br/>
                Hair nets are used for hygiene in food facilities, preventing hair and bacteria from contaminating food and prevents clean hands from touching the hair. Must cover hair and ears.</p>
                <p class="production_beard"><span>Beard protection</span><br/>
                    Beard snoods ensure food hygiene by preventing hair contamination and prevents clean hands from touching the beard; must cover all facial hair for effectiveness.</p>
                    <p class="production_sleeves"><span>Long sleeves</span><br/>
                        Long sleeves protect food from contamination, acting as a barrier to prevent bacteria and dirt transfer from the skin. And also ensures safety.</p>
                    <p class="production_shoes"><span>Safety shoes</span><br/>
                        Safety shoes protect against workplace hazards, offer slip resistance, stability, and meet regulatory standards. Furthermore the right shoes in the right area ensures the hygiene and food safety.</p>
                        <p class="production_hearing"><span>Hearing protection</span><br/>
                            Hearing protection is crucial to prevent noise-induced hearing loss, or preventing tinnitus. </p>
                        <p class="production_glasses"><span>Safety glasses</span><br/>
                            Safety glasses protect against hazards like flying debris, dust, chemical splashes, and UV radiation, essential for workplace safety.</p>
            <img class="production_doll" src="@/assets/img/ppe/result_production.png" alt="warehouse doll"/>
            <div class="btn_enter" @click="closeComponent">ENTER ROOM</div>
        </section>
        <section v-if="properties.scene == 'Milk reception'" class="milkreception_container">
            <p class="milkreception_bump"><span>Bump cap</span><br/>
                Bump caps protect from minor impacts and are ideal for areas with risk of accidental contact and moving or low-hanging objects.</p>
                <p class="milkreception_glasses"><span>Safety glasses</span><br/>
                    Safety glasses protect against hazards like flying debris, dust, chemical splashes, and UV radiation, essential for workplace safety.</p>
                    <p class="milkreception_vest"><span>High visibility vest</span><br/>
                        Hi-vis clothing ensures safety by enhancing visibility, thereby offering protection and preventing accidents.</p>
                    <p class="milkreception_shoes"><span>Safety shoes</span><br/>
                        Safety shoes protect against workplace hazards, offer slip resistance, stability, and meet regulatory standards. Furthermore the right shoes in the right area ensures the hygiene and food safety.</p>
                        <p class="milkreception_working"><span>Drivers Work Clothing</span><br/>
                            Safety-focused drivers' work clothing is high-visibility, weather-resistant, and provide protection and comfort.</p>
            <img class="milkreception_doll" src="@/assets/img/ppe/result_milkreception.png" alt="warehouse doll"/>
            <div class="btn_enter" @click="closeComponent">ENTER ROOM</div>
        </section>
    </div>
</template>
<script>
export default {
    name: "Solution",
    props: {
     properties: {},
     isMatching: null,
    },
    data() {
        return {
       
        };
    },
    mounted() {
    },
    methods: {
        
            closeComponent() {
            this.$emit("closeComponent")
        }
        

    },
    computed: {
        mediaPath() {
                return app.api.Utils.getMediaPath(this.properties.titleImage.src);
        }
    },
    
}
</script>
<style lang="scss" scoped>
.solution_container {
    position: relative;
    width: 1451px;
    height: 816px;
    background-color: var(--light-grey);
    border: 10px solid var(--beige-grey);
    border-radius: 20px;
}

.solution_img { 
    position: absolute;
    top: 65px;
    left: 50%;
    transform: translate(-50%, -50%);
}
.solution_title_img {
    position:absolute;
    top: 12px;
    left: 50%;
    transform: translate(-50%, -50%);
}

.solution_info{
    position: absolute;
    font-size: 15px;
    color: var(--md-black);
    font-family: "Arla Interface";
    font-weight: 700;
    font-style: normal;
    font-display: swap;
    top: 115px;
    left: 50%;
    transform: translate(-50%, -50%);
}
.solution_description {
    position: absolute;
    font-size: 15px;
    color: var(--md-black);
    font-family: "Arla Interface";
    font-weight: 700;
    font-style: normal;
    font-display: swap;
    top: 135px;
    left: 50%;
    transform: translate(-50%, -50%);
}
.btn_enter{
    position: absolute;
    font-size: 15px;
    color: var(--white);
    font-family: "Arla Interface";
    font-weight: 700;
    font-style: normal;
    font-display: swap;
    bottom:50px;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: var(--dark-green);
    padding: 8px 16px;
        border-radius: 20px;
        width: 150px;
        cursor: pointer;
}
.Warehouse {
    background-color: var(--yellow);
    padding: 0px 10px;
    border: solid 1px var(--yellow);
    border-radius: 10px;
    color: #FFFFFF;
    font-family: 'Arla Interface';
    font-weight: 300;
    font-style: normal;
    font-display: swap;
}
.warehouse_container {
    p{
    font-size: 15px;
    color: var(--md-black);
    font-family: "Arla Interface";
    font-weight: 500;
    font-style: normal;
    font-display: swap;
    
    }
    span {
        font-size: 15px;
    color: var(--md-black);
    font-family: "Arla Interface";
    font-weight: 700;
    font-style: normal;
    font-display: swap;
    }
.warehouse_bump{
    position: absolute;
    width: 300px;
    top: 260px;
    left: 159px;
    text-align: right; 
}
.warehouse_gloves{
    position: absolute;
    width: 300px;
    top: 550px;
    left: 159px;
    text-align: right; 
}
.warehouse_vest {
    position: absolute;
    width: 300px;
    top: 350px;
    left: 970px;
    text-align: left; 
}

.warehouse_glasses {
    position: absolute;
    width: 300px;
    top: 210px;
    left: 970px;
    text-align: left; 
}
.warehouse_shoes {
    position: absolute;
    width: 300px;
    top: 530px;
    left: 970px;
    text-align: left; 

}
}
.warehouse_doll {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.Production {
    background-color: var(--yellow);
    padding: 0px 10px;
    border: solid 1px var(--yellow);
    border-radius: 10px;
    color: #7C6D2A;
    font-family: 'Arla Interface';
    font-weight: 300;
    font-style: normal;
    font-display: swap;
}
.production_container {
    p{
    font-size: 15px;
    color: var(--md-black);
    font-family: "Arla Interface";
    font-weight: 500;
    font-style: normal;
    font-display: swap;
    
    }
    span {
        font-size: 15px;
    color: var(--md-black);
    font-family: "Arla Interface";
    font-weight: 700;
    font-style: normal;
    font-display: swap;
    }
    .production_glasses{
    position: absolute;
    width: 300px;
    top: 184px;
    left: 161px;
    text-align: right; 
}
.production_beard{
    position: absolute;
    width: 300px;
    top: 332px;
    left: 161px;
    text-align: right; 
}
.production_sleeves{
    position: absolute;
    width: 300px;
    left: 161px;
    top: 487px;
    text-align: right; 
}
.production_hair{
    position: absolute;
    width: 300px;
    top: 187px;
    left: 971px;
    text-align: left; 
}
.production_hearing{
    position: absolute;
    width: 300px;
    top: 345px;
    left: 971px;
    text-align: left; 
}
.production_shoes{
    position: absolute;
    width: 300px;
    top: 477px;
    left: 971px;

    text-align: left; 
}
}
.production_doll {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.Milk {
    background-color: var(--baby-blue);
    padding: 0px 10px;
    color: var(--petrol);
    border-radius: 10px;
    color: #007595;
    font-family: 'Arla Interface';
    font-weight: 300;
    font-style: normal;
    font-display: swap;
}
.milkreception_container {
    p{
    font-size: 15px;
    color: var(--md-black);
    font-family: "Arla Interface";
    font-weight: 500;
    font-style: normal;
    font-display: swap;
    
    }
    span {
        font-size: 15px;
    color: var(--md-black);
    font-family: "Arla Interface";
    font-weight: 700;
    font-style: normal;
    font-display: swap;
    }
.milkreception_bump {
    position: absolute;
    width: 300px;
    top: 197px;
    left: 970px;
    text-align: left; 
}
.milkreception_glasses {
    position: absolute;
    width: 300px;

    top: 257px;
    left: 161px;
    text-align: right; 
}
.milkreception_shoes {
    position: absolute;
    width: 300px;
    top: 477px;
    left: 970px;
    text-align: left; 
}
.milkreception_vest {
    position: absolute;
    width: 300px;
    top: 437px;
    left: 161px;
    text-align: right 
}
.milkreception_working {
    position: absolute;
    width: 300px;
    top: 347px;
    left: 970px;
    text-align: left 
}
}
.milkreception_doll {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
</style>